import { TeamAccessDTO } from '../team/team-access.dto';
import { ProductListDTO } from '../product/product-list.dto';

export class ManuscriptDTO extends TeamAccessDTO {

    name: string;

    content: string;

    type: number;

    product: ProductListDTO;

}
